module.exports = __webpack_public_path__ + "img/icons8-chicago copy.0a79612d.svg";